import { render, staticRenderFns } from "./SalesDeliveryStatusBadge.vue?vue&type=template&id=ae918388"
import script from "./SalesDeliveryStatusBadge.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports